import { getProfileName } from "PFCore/helpers/profile";
import { useProfilesOptions } from "PFCore/hooks/queries/profiles/use_profiles_options";

import { useCustomValuePreviewContext } from "../context/custom_value_preview_context";

export const useProfileName = () => {
  const { show, profileId, isUnbiasedMode, isClosing } = useCustomValuePreviewContext();

  const { data: profileName, isFetching: isFetchingProfileName } = useProfilesOptions<string>(
    { value: [profileId!] },
    {
      enabled: show && !isClosing && !isUnbiasedMode && !!profileId,
      select: (data) => getProfileName(data.entries[0])
    }
  );

  return {
    profileName,
    isFetchingProfileName
  };
};
